import type { FunctionComponent } from 'react'
import React from 'react'

import { TypographyV2 } from '../../../Foundations/Typography'
import styles from './PageTitle.module.scss'

export const PageTitle: FunctionComponent<PageTitleProps> = ({
  pageTitle,
  standfirst,
  pageTitleTag,
}) => {
  return (
    <div className={styles.pageTitle}>
      <TypographyV2
        className={styles.pageTitleHeading}
        tag={pageTitleTag}
        textStyle="sb-text-heading-page-title"
      >
        {pageTitle}
      </TypographyV2>

      {standfirst && (
        <TypographyV2
          className={styles.pageTitleStandfirst}
          textStyle="sb-text-heading-standfirst"
          tag={'p'}
        >
          {standfirst}
        </TypographyV2>
      )}
    </div>
  )
}
export type PageTitleProps = {
  /**
   * Page Title Sting
   */
  pageTitle: string
  /**
   * Standfirst String
   */
  standfirst?: string
  /**
   * Page Title Tag String
   */
  pageTitleTag: ValidTitleTags
}

type ValidTitleTags = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
